"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BodyDeleteMemberV1WorkspaceMembersDelete = exports.UpdateMemberRequest = void 0;
var UpdateMemberRequest_1 = require("./UpdateMemberRequest");
Object.defineProperty(exports, "UpdateMemberRequest", { enumerable: true, get: function () { return UpdateMemberRequest_1.UpdateMemberRequest; } });
var BodyDeleteMemberV1WorkspaceMembersDelete_1 = require("./BodyDeleteMemberV1WorkspaceMembersDelete");
Object.defineProperty(exports, "BodyDeleteMemberV1WorkspaceMembersDelete", { enumerable: true, get: function () { return BodyDeleteMemberV1WorkspaceMembersDelete_1.BodyDeleteMemberV1WorkspaceMembersDelete; } });
